import { Component, Input, OnInit } from '@angular/core';
import { MessageNotification } from 'src/app/shared/models/message-notification';

@Component({
	selector: 'app-dashboard-messaging',
	templateUrl: './dashboard-messaging.component.html',
	styleUrls: ['./dashboard-messaging.component.scss']
})
export class DashboardMessagingComponent {
	@Input() listNotification: MessageNotification[] = [];
	@Input() manyNewMessages: boolean = false;

	constructor() {}
}
